let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bneOJ")).then(() => parcelRequire('ibWo3'));